import {Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {DeepLinkType} from '@app/models/deep-link.model';
import {TrackingComponent} from '@app/shared/components/tracking/tracking.component';
import {UrlService} from '@app/services/url.service';
import {FingerprintService} from '@app/services/fingerprint.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ProductModel} from '@app/market-seo/models/product.model';
import {LazyLoad} from '@app/helpers/lazyload';
import {isPlatformBrowser} from '@angular/common';
import {ProductService} from '@app/marketplace/products/_services/product.service';
import {Observable} from 'rxjs';
import {MarketProduct} from '@app/marketplace/products/_models/product.interface';
import {Store} from '@ngrx/store';
import {finalize} from 'rxjs/operators';
import {StorageService} from '@app/services/storage.service';
import { ViewTypeEnum } from '@app/marketplace/core/enum/viewTypeEnum';

const lazyLoad = LazyLoad;
declare const $: any;

@Component({
  selector: 'app-products-section',
  templateUrl: './products-section.component.html',
  styleUrls: ['./products-section.component.css']
})
export class ProductsSectionComponent extends TrackingComponent implements OnInit {

  products: MarketProduct[] = [];
  payload: any;
  loading$: boolean;

  theme = { 'min-width': '220px', 'min-height': '219px', background: '#f1f1f1' };

  constructor(private urlService: UrlService,
              private fingerprintService: FingerprintService,
              private route: ActivatedRoute,
              private productService: ProductService,
              private storageService: StorageService,
              private store: Store<any>,
              @Inject(PLATFORM_ID) private platformId) {
    super(urlService, fingerprintService, null, route, 'stu_btn_market');
    this.payload = {
      pageIndex: 1,
      pageSize: 12,
      pagingStrategy: 0,
      locationType: 0,
      locations: null,
      locationResolver: false,
      filter: {
        searchTerms: '',
        sortingArgs: 0,
        categories: null,
        priceRange: {
          low: 1,
          high: 1000,
        },
      },
      categoryCode: '',
      supplierCode: '',
    };
  }

  ngOnInit(): void {
    this.updatePayload(1);
  }

  updatePayload(tab: number) {
      switch (tab) {
        case 1: this.payload.filter.sortingArgs = 0; break;
        case 2: this.payload.filter.sortingArgs = 16; break;
        case 3: this.payload.filter.sortingArgs = 4; break;
        case 4: this.payload.filter.sortingArgs = 128; break;
        default: this.payload.filter.sortingArgs = 0;
      }
      this.getProducts();
  }
  getProducts() {
    this.loading$ = true;
    const location = this.storageService.getCurrentLocation('location');
    if (location && location.isSuccess == true) {
      this.payload.locationType = location?.locationType || 0;
      this.payload.locations = location?.locations || null;
    }
    this.productService.ListProducts(this.payload).pipe(finalize(() => this.loading$ = false)).subscribe((result: any) => {
      if (result && result.data) {
        result.data.map(data => {
          data.ratingsCounter = new Array(Number(data.rating.toFixed(0)));
        });
        this.products = result.data;
      }
    });
  }

  public pushToCart(product: any, tab) {
    const itemImg = $(`#${tab}-${product.code}`).find('img').eq(0);
    this.flyToElement($(itemImg), product,ViewTypeEnum.ProductList, this.store);
  }
}
